import React from 'react';
import './WpBubble.scss';

const WpBubble: React.FC<{}> = React.memo(() => {
    const openWp = () => {
        window.location.href = 'https://wa.me/5493516532783';
    };

    return (
        <div 
            onClick={openWp}
            className="WpBubble">
            <p>COMUNICATE</p>
            <span className="WpIcon"></span>
        </div>
    )
});

export default WpBubble;